import React from 'react';
import PropTypes from 'prop-types';

const BookIcon = (props) => {
  return (
    <svg
      onClick={() => {
        props.openSpeechBubble(props.hsClass);
      }}
      onFocus={() => {
        props.openSpeechBubble(props.hsClass);
      }}
      onBlur={() => {
        props.closeClassPopUp();
      }}
      tabIndex={0}
      style={{ marginRight: '10px' }}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      width="25px"
      aria-label={props.ariaLabel || 'Book Icon'}
      role="button"
    >
      <title>Book Icon</title>
      <g>
        <path
          fill={props.color}
          d="M982,189.5h-49.8v-41.2c0-0.1,0-0.2,0-0.3c0-0.7-0.1-1.3-0.2-2c-0.1-0.5-0.1-1.1-0.2-1.6
            c-0.1-0.6-0.4-1.2-0.5-1.7c-0.2-0.6-0.3-1.1-0.6-1.6s-0.5-1-0.8-1.5c-0.3-0.5-0.6-1-0.9-1.5s-0.7-0.9-1.1-1.4
            c-0.4-0.4-0.7-0.9-1.1-1.3c-0.4-0.4-0.9-0.8-1.4-1.2c-0.4-0.3-0.8-0.7-1.3-1c-0.5-0.3-1-0.6-1.5-0.8c-0.5-0.3-1.1-0.6-1.6-0.8
            c-0.5-0.2-1-0.3-1.5-0.5c-0.6-0.2-1.3-0.4-1.9-0.5c-0.1,0-0.2-0.1-0.3-0.1c-29.5-4.9-59.7-7.4-89.8-7.4l0,0
            c-119.8,0-232.6,38.1-327.4,110c-94.8-72-207.6-110-327.4-110c-30.1,0-60.3,2.5-89.8,7.4c-0.1,0-0.2,0.1-0.3,0.1
            c-0.7,0.1-1.3,0.3-1.9,0.5c-0.5,0.2-1,0.3-1.5,0.5c-0.6,0.2-1.1,0.5-1.6,0.8c-0.5,0.3-1,0.5-1.5,0.8c-0.5,0.3-0.9,0.7-1.3,1
            c-0.5,0.4-0.9,0.7-1.4,1.1c-0.4,0.4-0.8,0.8-1.1,1.3c-0.4,0.4-0.8,0.9-1.1,1.3c-0.3,0.5-0.6,1-0.9,1.5c-0.3,0.5-0.6,1-0.8,1.5
            c-0.2,0.5-0.4,1.1-0.5,1.6c-0.2,0.6-0.4,1.1-0.6,1.8c-0.1,0.5-0.1,1-0.2,1.5c-0.1,0.7-0.2,1.3-0.2,2c0,0.1,0,0.2,0,0.3v41.2H18
            c-10,0-18,8.1-18,18v651.3c0,10,8.1,18,18,18H982c10,0,18-8.1,18-18V207.5C1000,197.6,991.9,189.5,982,189.5z M827.4,159.1
            c23,0,46.1,1.6,68.8,4.7v566.5c-22.7-2.9-45.8-4.3-68.8-4.3c-112.2,0-218.3,33.4-309.2,96.8V264.6
            C607.4,195.6,714,159.1,827.4,159.1z M482.1,264.8V823c-91-63.5-197.2-97-309.5-97c-23,0-46,1.5-68.8,4.3V163.9
            c22.7-3.1,45.8-4.7,68.8-4.7C286.1,159.1,392.9,195.7,482.1,264.8z M36,225.6h31.8v525.6c0,0.5,0.1,1,0.2,1.5c0,0.5,0,1,0.1,1.5
            c0,0.1,0.1,0.2,0.1,0.3c0.1,0.7,0.3,1.3,0.5,1.9c0.2,0.5,0.3,1,0.5,1.5c0.2,0.6,0.5,1.1,0.8,1.6c0.3,0.5,0.5,1,0.8,1.5
            c0.3,0.5,0.7,0.9,1.1,1.4c0.4,0.4,0.7,0.9,1.1,1.3c0.4,0.4,0.9,0.8,1.4,1.2c0.4,0.3,0.8,0.7,1.2,1c0.5,0.4,1.1,0.7,1.7,1
            c0.5,0.2,0.9,0.5,1.3,0.7c0.6,0.3,1.2,0.4,1.8,0.6c0.5,0.2,1,0.4,1.6,0.5s1.1,0.2,1.7,0.2c0.6,0.1,1.2,0.2,1.9,0.2
            c0.1,0,0.2,0,0.3,0c0.5,0,1-0.1,1.5-0.2c0.5,0,1,0,1.4-0.1c27.5-4.6,55.7-6.9,83.8-6.9c97.7,0,190.4,27.1,271.3,78.8H36V225.6z
            M964,840.8H556.1c80.9-51.6,173.6-78.8,271.3-78.8c28.1,0,56.3,2.3,83.8,6.9c0.5,0.1,1,0,1.4,0.1c0.5,0,1,0.2,1.5,0.2
            c0.1,0,0.2,0,0.3,0c0.7,0,1.3-0.1,2-0.2c0.5-0.1,1.1-0.1,1.6-0.2c0.6-0.1,1.2-0.3,1.7-0.5c0.5-0.2,1.1-0.3,1.6-0.5
            c0.5-0.2,1-0.6,1.5-0.8c0.5-0.3,1-0.5,1.5-0.9c0.5-0.4,0.9-0.8,1.4-1.1c0.4-0.4,0.9-0.7,1.2-1.1c0.4-0.4,0.8-0.9,1.2-1.4
            c0.3-0.4,0.7-0.8,1-1.3c0.3-0.5,0.6-1,0.8-1.5c0.3-0.5,0.6-1,0.8-1.6c0.2-0.5,0.3-1,0.5-1.5c0.2-0.6,0.4-1.3,0.5-2
            c0-0.1,0.1-0.2,0.1-0.3c0.1-0.5,0.1-1,0.1-1.4c0-0.5,0.2-1,0.2-1.5V225.6H964C964,225.6,964,840.8,964,840.8z"
        />
      </g>
    </svg>
  );
};

export default BookIcon;

BookIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
